// Phones methods
// Carrega um item no state
export const loadPhone = (key, component) => {
    const { phones } = component.state;
    let output = undefined;

    if (phones.length > 0) {
        var item = phones.find(x => { return x.key == key });
        output = item !== undefined ? item : undefined;
    }

    return output;
}

// Monta a lista no state
export const mountItems = (component) => {

    const { totalPhoneItems, phones } = component.state;

    const deleteRequested = phones.filter(x => x.isDeleteRequested === true);

    let newPhones = [];

    for (let i = 0; i < totalPhoneItems; i++) {

        let itemKey = i + 1;

        //Default values

        let defaultPhoneType = undefined;
        let defaultPhoneNumber = undefined;

        let defaultItemId = null;
        let defaultPersonId = null;

        let itemPhoneType = defaultPhoneType;
        let itemPhoneNumber = defaultPhoneNumber;
        let itemPersonId = defaultItemId;
        let itemId = defaultPersonId;

        let phone = loadPhone(itemKey, component);

        if (phone !== undefined) {
            itemId = phone['id'] || defaultItemId;
            itemPersonId = phone['personId'] || defaultPersonId;
            itemPhoneType = phone['phoneType'] || defaultPhoneType;
            itemPhoneNumber = phone['phoneNumber'] || defaultPhoneNumber;

        }

        newPhones.push({
            key: itemKey,
            id: itemId,
            personId: itemPersonId,
            phoneNumber: itemPhoneNumber,
            phoneType: itemPhoneType,
            orderNumber: i
        });
    }

    let finalPhones = [...newPhones, ...deleteRequested];
    
    component.setState({ phones: finalPhones });
}

//Carrega as informações de um campo específico do item no state
export const phonesFormValue = (key, formField, component) => {

    let output = undefined;

    var item = loadPhone(key, component);

    output = item !== undefined ? item[formField] : undefined;

    return output;

}

//Tratativas para quando um campo muda de valor (geral)
export const handleChangePhones = (key, event, component) => {
    const { value, checked, type } = event.target;

    const name = event.target.getAttribute('data-field-name');

    const changeValue = type == "checkbox" ? checked : value;

    handleFieldChange(key, name, changeValue, component);
}


//Método genérico para acompanhar tratativas de mudança de valor dos campos
export const handleFieldChange = (key, field, value, component) => {
    var item = loadPhone(key, component);

    item[field] = value;

    const newPhones = changePhonesList(component, item);

    let finalOptions = beforeChangePhonesState(key, field, value, newPhones, component);

    component.setState({
        phones: finalOptions
    });
}

//Método para executar tratamentos antes da mudança para o novo state do formulário
export const beforeChangePhonesState = (key, changedField, changeValue, newPhones, component) => {
    const { form } = component.state;
    let output = newPhones;

    return output;
}

//Prapara o objeto do state para a atualização com as informações das alternativas da questão
export const changePhonesList = (component, targetOption, remove = false) => {
    let { phones } = component.state;

    let optionIndex = phones.findIndex(option => option.key == targetOption.key);

    if (remove === true) {
        let elementId = phones[optionIndex]['id'] || undefined;

        if (elementId) {
            phones[optionIndex]['isDeleteRequested'] = true;
            phones[optionIndex]['key'] = 'delete-requested-' + new Date().getTime();
        } else {
            phones.splice(optionIndex, 1);
        }
    } else {
        phones[optionIndex] = targetOption;
    }

    return phones;
}


const phonesFunctions = {
    loadPhone,
    phonesFormValue,
    handleChangePhones,
    beforeChangePhonesState,
    changePhonesList,
    mountItems
}

export default phonesFunctions;